import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Filters from '../../components/Filters/Filters';
import Select from '../../components/Inputs/Select/Select';

import { download } from '../../helper/FileHelper';
import { removePagingAndSorting } from '../../helper/PaginationHelper';

import { optionsConteudo } from '../../variables/Enums/ObjetoPostal';

export class ObjetoPostalConteudoFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                conteudo: '',
            },
            exportPlan: false,
            count: 0,
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: { ...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                conteudo: filters.find(f => f.field === 'conteudo') ? filters.find(f => f.field === 'conteudo').value : null,
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })
    }

    // FILTROS
    handleFilterApply = () => {
        const f = [];
        const { filters, exportPlan } = this.state;

        if (filters.conteudo) f.push({ field: 'conteudo', value: filters.conteudo })

        if (exportPlan) {
            f.push({ field: 'exportarPlanilha', value: exportPlan });

            this.props.export(f)
                .then(res => download(res))
                .finally(() => this.setState({ exportPlan: false }));
        } else {
            this.props.handleFilterChange(f);
        };
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
            filters: {
                conteudo: '',
            },
            exportPlan: false,
            count: 0,
        })

        this.props.handleFilterChange([], false);
    }

    // CONTAGEM DE FILTROS ATIVOS
    handleCountFilters = () => this.state.count;

    render() {
        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
            >
                <Grid item container spacing={4}>
                    <Grid item sm={12} lg={4}>
                        <Select
                            label="Conteúdo"
                            name='conteudo'
                            value={this.state.filters.conteudo}
                            options={optionsConteudo}
                            onChange={(e) => this.handleChange(e)}
                        />
                    </Grid>
                </Grid>
            </Filters>
        )
    }
}

export default ObjetoPostalConteudoFilter;